import DealCallCenter from "@/views/modules/call_center/deals/DealCallCenter.vue";
import DealFormView from "../../views/modules/sales/deals/DealFormView";
import CustomersList from "../../components/customers/CustomersList";
import LeadsList from "../../components/customers/LeadsList";
import DocumentList from "../../views/modules/sales/documents/DocumentList";
import ProspectsCallCenter from "@/views/modules/call_center/ProspectsCallCenter.vue";
import CollectionListCallCenter from "@/views/modules/call_center/collections/CollectionListCallCenter.vue"; //REPORTE DE COBRO EN MÓDULO DE SOPORTE DE VENTAS
import roles from "@/roles";
import layouts from "../../layout";
import training from "../../views/modules/sales/training/mview/index";
import channelMview from "../../views/modules/sales/training/mview/channelMview.vue";
import store from "@/store";
import { COMPANYS } from "@/const";

export default {
  path: "/call-center",
  name: "call-center",
  component: () =>
    import(
      /* webpackChunkName: "CallCenter" */ "@/views/modules/call_center/CallCenter.vue"
    ),
  redirect: {
    name: "call-center-prospects"
  },
  meta: {
    auth: true,
    title: "Call Center",
    tags: ["call-center"],
    title_i18n: "call-center.main"
  },
  children: [
    {
      path: "leads",
      name: "call-center-leads",
      component: LeadsList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Leads",
        title_i18n: "call-center.breadcrumb.leads",
        tags: ["call-center", "leads"],
        index: true
      }
    },
    {
      path: "prospects",
      name: "call-center-prospects",
      component: ProspectsCallCenter,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Prospects",
        tags: ["call-center", "prospects"],
        review: true
      },
      redirect: {
        name: "call-center-prospects-list"
      },
      children: [
        {
          path: "",
          alias: "/",
          name: "call-center-prospects-list",
          component: () =>
            import(
              /* webpackChunkName: "ProspectList" */ "@/components/prospects/ProspectList.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "List",
            title_i18n: "call-center.breadcrumb.prospects-list",
            tags: ["call-center", "prospects", "list"],
            index: true
          }
        },
        {
          path: "create",
          name: "call-center-prospects-create",
          component: () =>
            import("../../views/modules/call_center/ProspectCreate.vue"),
          meta: {
            auth: true,
            searchable: false,
            layout: layouts.navLeft,
            title: "Create",
            title_i18n: "call-center.main",
            tags: ["call-center", "prospect", "create"]
          }
        }
      ]
    },
    {
      path: "deals",
      name: "call-center-deals",
      component: DealCallCenter,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Deals",
        tags: ["call-center", "deals"],
        review: true
      },
      redirect: {
        name: "call-center-deals-list"
      },
      children: [
        {
          path: "",
          alias: "/",
          name: "call-center-deals-list",
          component: () =>
            import("@/views/modules/call_center/deals/index.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "List",
            title_i18n: "call-center.breadcrumb.deals-list",
            tags: ["call-center", "deals", "list"],
            index: true
          }
        },
        {
          path: "create",
          props: {
            ClientCode: {
              type: String,
              required: false
            }
          },
          name: "call-center-deals-create",
          component: () =>
            import(
              /* webpackChunkName: "NewDeals" */ "../../views/modules/sales/deals/NewDeals.vue"
            ),
          meta: {
            auth: true,
            searchable: false,
            layout: layouts.navLeft,
            title: "Create",

            tags: ["call-center", "deals", "create"]
          }
        },
        {
          path: ":id",
          name: "call-center-deals-view",
          component: DealFormView,
          meta: {
            auth: true,
            searchable: false,
            layout: layouts.navLeft,
            title: "Deal",

            tags: ["call-center", "deals"]
          }
        }
      ]
    },
    {
      path: "customers",
      name: "call-center-customers",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Customers",
        tags: ["call-center", "customer"],
        index: true
      },
      children: [
        {
          path: "customers",
          name: "call-center-customers",
          component: CustomersList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Customers",
            tags: ["call-center", "customer"],
            index: true
          }
        },
        {
          path: "kpi-sla-per-Customers",
          name: "call-center-kpi-sla-per-Customers-in-customers",
          component: () =>
            import("@/views/modules/sales/kpi/SLAPorClienteKPI.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI SLA Por Clientes",
            tags: ["sales", "deals", "list", "SLA", "kpi", "customers"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-satisfaction-per-Customers",
          name: "call-center-kpi-satisfaction-per-Customers-in-customers",
          component: () =>
            import("@/views/modules/sales/kpi/SatisfaccionPorClientesKPI"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Satisfaccion Por Clientes",
            tags: [
              "sales",
              "deals",
              "list",
              "satisfaction",
              "kpi",
              "customers"
            ],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
      ]
    },
    /*
    {
      path: "report-devices-call-center",
      name: "report-devices-by-client-call-center",
      component: () =>
        import(
          /* webpackChunkName: "ReportDevices" / "@/views/modules/call_center/ReportDevicesByClients"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "REPORTE EQUIPOS POR CLIENTES",
        tags: ["report", "sales", "list", "devices"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      }
    },
    */
    {
      path: "documents",
      name: "call-center-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        title_i18n: "call-center.breadcrumb.documents",
        tags: ["call-center", "documents"],
        index: true
      }
    },
    {
      path: "collections",
      name: "call-center-collections",
      component: CollectionListCallCenter,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Collections",
        title_i18n: "call-center.breadcrumb.documents",
        tags: ["call-center", "collections"],
        index: true
      }
    },
    {
      path: "training",
      name: "training",
      component: training,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Entrenamientos",
        tags: ["training"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "call-center-training-magytrack",
          name: "call-center-training-traning-magytrack",
          component: () =>
            import(
              "../../views/modules/call_center/training/magytrack/Magytrack"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "magytrack",
            tags: ["call-center", "training", "magytrack"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
          },
          children: [
            {
              path: "call-center-user-manual",
              name: "call-center-training-user-manual",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/userManualMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["call-center", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-link-channel-magytrack",
              name: "call-center-training-link-channel-magytrack",
              component: channelMview,
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["call-center", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-mview-magytrack",
              name: "call-center-training-magytrack-contract",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/contractMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["call-center", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-test-magytrack",
              name: "call-center-training-test-magytrack",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/testMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["call-center", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-training-presentation-magytrack",
              name: "call-center-training-presentation-magytrack",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/presentationMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["call-center", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-product-presentation-magytrack",
              name: "call-center-training-product-presentation-magytrack",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/presentationProductMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: [
                  "call-center",
                  "training",
                  "presentationProductmagytrack"
                ],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-price-list-magytrack",
              name: "call-center-training-price-list-magytrack",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/priceListMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["call-center", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-model-contract-magytrack",
              name: "call-center-training-model-contract-magytrack",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magytrack/contractMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["call-center", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "call-center-training-mview",
          name: "call-center-training-traning-mview",
          component: () =>
            import("../../views/modules/call_center/training/mview/Mview"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Mview",
            tags: ["call-center", "training", "Mview"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "call-center-user-manual",
              name: "call-center-training-user-manual-mview",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/userManualMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["call-center", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-link-channel-mview",
              name: "call-center-training-link-channel-mview",
              component: channelMview,
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["call-center", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-mview-contract",
              name: "call-center-training-mview-contract",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/contractMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["call-center", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-test-mview",
              name: "call-center-training-test-mview",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/testMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["call-center", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-training-presentation-mview",
              name: "call-center-training-presentation-mview",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/presentationMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["call-center", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-product-presentation-mview",
              name: "call-center-training-product-presentation-mview",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/presentationProductMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["call-center", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-price-list-mview",
              name: "call-center-training-price-list-mview",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/priceListMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["call-center", "training", "priceListMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-model-contract-mview",
              name: "call-center-training-model-contract-mview",
              component: () =>
                import(
                  "../../views/modules/call_center/training/mview/modelContractMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["call-center", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "call-center-training-mpago",
          name: "call-center-training-mpago",
          component: () =>
            import("../../views/modules/call_center/training/magypago/Mpago"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Mpago",
            tags: ["call-center", "training", "mpago"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "call-center-user-manual-mpago",
              name: "call-center-training-user-manual-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/userManualMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["call-center", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-link-channel-mpago",
              name: "call-center-training-link-channel-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/channelMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["call-center", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-mpago-contract",
              name: "call-center-training-mpago-contract",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/contractMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["call-center", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-mpago-contract",
              name: "call-center-training-mpago-terminalManual",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["call-center", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-test-mpago",
              name: "call-center-training-test-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/testMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["call-center", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-training-presentation-mpago",
              name: "call-center-training-presentation-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/presentationMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["call-center", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-product-presentation-mpago",
              name: "call-center-training-product-presentation-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/presentationProductMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["call-center", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-price-list-mpago",
              name: "call-center-training-price-list-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/priceListMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["call-center", "training", "priceListMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-model-contract-mpago",
              name: "call-center-training-model-contract-mpago",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magypago/modelContractMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["call-center", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "call-center-training-magyloterry",
          name: "call-center-training-magyloterry",
          component: () =>
            import(
              "../../views/modules/call_center/training/magyloterry/magyloterry"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Magyloterry",
            tags: ["call-center", "training", "magylottery"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "call-center-user-manual",
              name: "call-center-training-user-manual-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/userManualLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["call-center", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-link-channel-loterry",
              name: "call-center-training-link-channel-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/channelLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["call-center", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-mview-contract",
              name: "call-center-training-Lottery-contract",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/contractLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["call-center", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-Lottery-contract",
              name: "call-center-training-Lottery-terminalManual",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["call-center", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-test-Lottery",
              name: "call-center-training-test-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/testLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["call-center", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-training-presentation-Lottery",
              name: "call-center-training-presentation-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/presentationLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["call-center", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-product-presentation-Lottery",
              name: "call-center-training-product-presentation-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/presentationProductLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["call-center", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-price-list-Lottery",
              name: "call-center-training-price-list-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/priceListLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["call-center", "training", "priceListLottery"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-model-contract-Lottery",
              name: "call-center-training-model-contract-Lottery",
              component: () =>
                import(
                  "../../views/modules/call_center/training/magyloterry/modelContractLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["call-center", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "call-center-training-seahourse",
          name: "call-center-training-seahourse",
          component: () =>
            import(
              "../../views/modules/call_center/training/seahourse/seahourse"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Seahourse",
            tags: ["call-center", "SEAHORSE", "training"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "call-center-user-manual",
              name: "call-center-training-user-manual-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/userManualseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["call-center", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-link-channel-seahourse",
              name: "call-center-training-link-channel-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/channelseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["call-center", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-seahourse-contract",
              name: "call-center-training-seahourse-contract",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/contractseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["call-center", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-seahourse-contract",
              name: "call-center-training-seahourse-terminalManual",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["call-center", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-test-seahourse",
              name: "call-center-training-test-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/testseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["call-center", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-training-presentation-seahourse",
              name: "call-center-training-presentation-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/presentationseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["call-center", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-product-presentation-seahourse",
              name: "call-center-training-product-presentation-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/presentationProductseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["call-center", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-price-list-seahourse",
              name: "call-center-training-price-list-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/priceListseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["call-center", "training", "priceListLottery"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "call-center-model-contract-seahourse",
              name: "call-center-training-model-contract-seahourse",
              component: () =>
                import(
                  "../../views/modules/call_center/training/seahourse/modelContractseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["call-center", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        }
      ]
    }
    // {
    //   path: "reportsurvey",
    //   name: "employees-reportsurvey",
    //   component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Respuesta de Empleados",
    //     index: true,
    //     // Pass props to the component
    //     props: {
    //       // Define your props here
    //       prop1: "value1",
    //       prop2: "value2"
    //       // ...,
    //     }
    //   }
    // }
  ]
};
